import { Button, Card, CardContent, Grid, IconButton, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";
import AcademicoService from "../../services/AcademicoService";
import AlertService from "../../services/AlertService";
import AyudantiaService from "../../services/AyudantiaService";
import { DataSolicitudAyudantiasProy } from "../../interfaces/UTILS/DataBsqProy";
import React from "react";
import { format, isValid, parse } from "date-fns";
import { AyudanteInvInfo } from "../../interfaces/AYUDANTIAS/AyudanteInvInfo";
import { MdDelete, MdDetails, MdDocumentScanner, MdEdit, MdEditDocument, MdOutlineDetails } from "react-icons/md";
import { Edit } from "@mui/icons-material";
import { AyudantiaInvestigacion, VoidAyudantiaInvestigacion } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { useAppSelector } from "../../redux/hooks";
import { EstudianteActivoT, VoidEstudianteActivo } from "../../interfaces/SAAC/EstudianteActivo";
import { SmallModal } from "../../common/SmallModal";
import { SolicitarAyudForm } from "../Formularios/SolicitarAyudForm";
import { TblDecInvProyectoAyud } from "../../interfaces/AYUDANTIAS/TblDecInvProyectoAyud";

const alertaService = new AlertService();
const academicoService = new AcademicoService();
const ayudantiaService = new AyudantiaService();

interface Column {
  id: 'matricula' | 'nombre' | 'horas'|'horasOtorgadas'| 'finan' | 'termino' | 'fecha' | 'estadoDelegado'|'estadoVice' |'opciones';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
    { id: 'matricula', label: 'Matrícula', minWidth: 100 },
    { id: 'nombre', label: 'Nombre', minWidth: 170 },
    { id: 'horas', label: 'Horas solicitadas', minWidth: 50 },
    { id: 'horasOtorgadas', label: 'Horas otorgadas', minWidth: 50 },
    { id: 'finan', label: 'Financiamiento', minWidth: 170 },
    { id: 'termino', label: 'Término', minWidth: 50 },
    {
      id: 'fecha',
      label: 'Fecha',
      minWidth: 85,
    },
    {
      id: 'estadoDelegado',
      label: 'Estado Delegado',
      minWidth: 100,
    },
    // {
    //   id: 'estadoDirectivo',
    //   label: 'Estado Directivo',
    //   minWidth: 100,
    // },
    {
      id: 'estadoVice',
      label: 'Estado Vicerrectorado',
      minWidth: 100,
    },
    {
      id: 'opciones',
      label: 'Opciones',
      minWidth: 100,
    },
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#243165",
      color: theme.palette.common.white,
      zIndex: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      zIndex: -1,
    },
}));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  interface Props {
    data: DataSolicitudAyudantiasProy;
  }


export const BusqProyAyudantiasTable : React.FC<Props> = ( {data} ) => {
    //console.log(data);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(data.rowsPerPage[0]);
    const [detalleData, setDetalleData] = React.useState<AyudantiaInvestigacion>(VoidAyudantiaInvestigacion());
    let [estudiante, setEstudiante] = React.useState<EstudianteActivoT>(VoidEstudianteActivo());
    const [isModalDetalle, setIsModalDetalle] = React.useState<boolean>(false);
    const [isModalEliminar, setIsModalEliminar] = React.useState<boolean>(false);
    const [isModalEditar, setIsModalEditar] = React.useState<boolean>(false);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const token = useAppSelector((state) => state.authReducer.token);

    function PeriodoActual(dato: AyudanteInvInfo) {
      return dato.termino+"-"+dato.anio === data.periodoActivo.termino+"-"+data.periodoActivo.anio;
    }

    function DentroPeriodoAyudantias(): boolean {
      let bandera = false;
      const today = new Date();
      if (data.fechasAyudantias.estado === 1) {
        const fechaInicio = new Date(data.fechasAyudantias.fechaaperturaayudantias);
        const fechaFin = new Date(data.fechasAyudantias.fechacierreayudantias);
        bandera = today >= fechaInicio && today <= fechaFin;
      }
      return bandera;
    }

    
    const handleSearchDetalle = async (id: number) => {
      try {
        await ayudantiaService.GetSolicitudAyudantiaById(data.token, id)
          .then((data) => {
            setDetalleData(data.data);
            consultarEstudiante(data.data.proyectoAyud.codEstudiante);
          })
          .catch((error) => {
            console.error(error)
          });
      } catch (error) {
        console.error('Error:', error);
      }
    };

    async function consultarEstudiante(codestudiante: string) {
      const resp = await academicoService.GetCarreraActivaByMatricula(data.token, codestudiante,'I');
      if (resp.status.isSuccessfully) {
          setEstudiante(resp.data);
      } else {
          console.error(resp.status.messages)
      }
    }

    const handleOpenModal = async (data: AyudanteInvInfo) => {
      alertaService.showLoading("Cargando detalle...");
      await handleSearchDetalle(data.iddetallesolicitud);
      setTimeout(() => {
        setIsModalDetalle(true);
        alertaService.hideLoading();
      }, 1000);
    };

    const handleCloseModal = () => {
      setIsModalDetalle(false);
    };

    const handleOpenModalEliminar = async (data: AyudanteInvInfo) => {
      alertaService.showLoading("Cargando información...");
      await handleSearchDetalle(data.iddetallesolicitud);
      setTimeout(() => {
        setIsModalEliminar(true);
        alertaService.hideLoading();
      }, 1000);
    };
    const handleCloseModalEliminar = () => {
      setIsModalEliminar(false);
    };

    const handleOpenModalEditar = async (data: AyudanteInvInfo) => {
      alertaService.showLoading("Cargando información...");
      await handleSearchDetalle(data.iddetallesolicitud);
      setTimeout(() => {
        setIsModalEditar(true);
        alertaService.hideLoading();
      }, 1000);
    };
    const handleCloseModalEditar = () => {
      setIsModalEditar(false);
    };

    const handleResponseForm = async (responseData: TblDecInvProyectoAyud) => {
      setIsModalEditar(false);
      //console.log("Respuesta luego de la ejecución")
      //console.log(responseData);
      if (responseData.iddecinvproyecto > 0) {
        if(data.onActionEdit)
          data.onActionEdit();
        //alertaService.alertaExito("éxito", "Se actualizó la solicitud edit");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1500);
      }
    };

    const EliminarAyudantia = (id: number) => {
      //console.log(id);
      setIsModalEliminar(false);
      alertaService.showLoading('Espere...')
      ayudantiaService.DeleteSolicitudAyudantiaInvByIdDetalle(id, token)
        .then((response) => {
          alertaService.hideLoading()
          if (response.status.isSuccessfully) {
            alertaService.alertaExito("Éxito", "Se elimino la solicitud");
            if(data.onActionEdit)
              data.onActionEdit()
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          } else {
            alertaService.alertaAdvertenciaList("Alerta", response.status.messages[0].split('|').filter(msg => msg.trim() !== ''));
          }
        }).catch((error) => {
          console.error(error)
          alertaService.hideLoading()
          alertaService.alertaAdvertencia("Alerta", "No se completo el proceso")
        });
    }

    function estadoTexto(estado:string):string{
      let texto = '';
      switch(estado){
        case 'P':
          texto = 'Pendiente';
          break;
        case 'A':
          texto = 'Aprobado';
          break;
        case 'N':
          texto = 'Rechazado';
          break;
        case 'X':
          texto = 'Anulada';
          break;
        case 'R':
          texto = 'Reservado-Aprobado';
          break;
        case 'E':
          texto = 'Reservado-Rechazado';
          break;
        case 'G':
          texto = 'Negado-Aprobado';
          break;
        default:
           return '';
      }
      return texto;
    }

    return(
        <Paper sx={{ width: '100%', overflow: 'hidden', minHeight: '50vh' }}>
            <TableContainer sx={{ maxHeight: 600 }}>
                <Table>
                    <TableHead> 
                        <TableRow sx={{ backgroundColor: "#243165" }}>
                            {columns.map((column) => (
                                <StyledTableCell
                                style={{ minWidth: column.minWidth }}
                                key={column.id}
                                align={column.align}>
                                {column.label}
                                </StyledTableCell>
                            ))}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {   data.data.length > 0 ? data.data
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row)=>{
                            return(
                                <StyledTableRow key={row.idayudantiaproyecto}>
                                    <StyledTableCell component="th" scope="row">
                                    {row.codestudiante}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">{row.nombreEstudiante}</StyledTableCell>
                                    <StyledTableCell align="left">{row.horas}</StyledTableCell>
                                    {
                                      row.horasOtorgadas!=null 
                                      ?
                                      row.horasOtorgadas!=0 ?
                                      <StyledTableCell align="left">{row.horasOtorgadas}</StyledTableCell>
                                      :<StyledTableCell align="left">-</StyledTableCell>
                                      :<StyledTableCell align="left">-</StyledTableCell>
                                    }

                                    <StyledTableCell align="left">{row.financiamientoTexto}</StyledTableCell>
                                    <StyledTableCell align="left">{row.termino+"-"+row.anio}</StyledTableCell>
                                    <StyledTableCell align="left">
                                    {row.fechasolicitud 
                                      ? (() => {
                                          const parsedDate = parse(row.fechasolicitud.toString(), 'dd/MM/yyyy', new Date());
                                          return isValid(parsedDate) ? format(parsedDate, 'dd/MMM/yyyy') : "Fecha no disponible";
                                        })()
                                      : "Fecha no disponible"}
                                    </StyledTableCell>
                                    {/* <StyledTableCell align="left">{row.estadoDelegado}</StyledTableCell> */}
                                    <StyledTableCell align="left">{row.estadoSubdecano}</StyledTableCell>
                                    <StyledTableCell align="left">{row.estadoVicerrectorado}</StyledTableCell>
                                    <StyledTableCell align="left">
                                      <Grid>
                                        {
                                          PeriodoActual(row) && DentroPeriodoAyudantias() && row.estadoSubdecano=== "PENDIENTE"? 
                                          <Tooltip title={"Editar"} placement="top" arrow>
                                            <IconButton aria-label="Editar" color="primary" onClick={()=>{handleOpenModalEditar(row)}}>
                                              <MdEdit />
                                            </IconButton>
                                          </Tooltip>
                                          :
                                          <Tooltip title={"Detalle"} placement="top" arrow>
                                            <IconButton aria-label="Detalle" color="primary" onClick={()=>{handleOpenModal(row)}}>
                                              <MdEditDocument />
                                            </IconButton>
                                          </Tooltip>
                                        }
                                        {PeriodoActual(row) && DentroPeriodoAyudantias() && row.estadoSubdecano === 'PENDIENTE' ?
                                          <Tooltip title={"Eliminar"} placement="top" arrow >
                                            <IconButton aria-label="Eliminar" color="error" onClick={() => {handleOpenModalEliminar(row)}}>
                                              <MdDelete />
                                            </IconButton>
                                          </Tooltip>
                                          : <></>
                                        }
                                        
                                      </Grid>
                                    </StyledTableCell>

                                </StyledTableRow>
                            )
                        })
                        :
                        <StyledTableRow key={0}>
                            <StyledTableCell colSpan={10} component="th" scope="row" align="center">{'Sin resultados'}</StyledTableCell>
                        </StyledTableRow>
                    
                    }
                    </TableBody>
                </Table>
                
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={data.rowsPerPage}
                component="div"
                count={data.data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

          <SmallModal
            title='Detalle Solicitud'
            open={isModalDetalle}
            onClose={handleCloseModal}
            content={<>
            <Card sx={{ margin: 2 }}>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {detalleData.tituloProyecto}
                  </Typography>
                  {/* Sección de Itinerario */}
                  <Typography variant="h6" sx={{ marginTop: 2 }}>
                    Datos de la Solicitud
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="body1"><strong>Estudiante:</strong> {detalleData.estudiante}</Typography>
                      <Typography variant="body1"><strong>Descripción:</strong> {detalleData.proyectoAyud.descripcion}</Typography>
                      <Typography variant="body1"><strong>Termino:</strong> {detalleData.proyectoAyud.termino+"-"+detalleData.proyectoAyud.anio}</Typography>
                      <Typography variant="body1"><strong>Número de Horas solicitadas:</strong> {detalleData.detalle.numhoras+" horas"}</Typography>
                      <Typography variant="body1"><strong>Número de Horas Otorgadas:</strong> {detalleData.detalle.numhorasotorgadas+" horas"}</Typography>
                    </Grid>
                    {detalleData.gestion.find(x => x.tipopersona === 'S') !== null ?
                    <Grid item xs={12} sm={12}>
                      <Typography variant="body1"><strong>Estado Decanato de Investigación:</strong></Typography>
                      <Typography variant="body1">{estadoTexto(detalleData.gestion.find(x => x.tipopersona === 'S')?.estado??'')}</Typography>
                      <Typography variant="body1"><strong>Comentario:</strong> {detalleData.proyectoAyud.comentario}</Typography>
                    </Grid> 
                    :<></>  
                    }
                    {detalleData.gestion.find(x => x.tipopersona === 'V') !== null ?
                    <Grid item xs={12} sm={12}>
                      <Typography variant="body1"><strong>Respuesta Vicerrectorado:</strong></Typography>
                      <Typography variant="body1">{detalleData.gestion.find(x => x.tipopersona === 'V')?.observacion}</Typography>
                      <Typography variant="body1"><strong>Estado:</strong>{estadoTexto(detalleData.gestion.find(x => x.tipopersona === 'V')?.estado??'')}</Typography>
                    </Grid> 
                    :<></>  
                    }
                  </Grid>
                </CardContent>
              </Card>
                    </>}
          />

          <SmallModal
            title='Editar Solicitud'
            open={isModalEditar}
            onClose={handleCloseModalEditar}
            content={<>
            <Card sx={{ margin: 2 }}>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {detalleData.tituloProyecto}
                  </Typography>
                  {/* Sección de Itinerario */}
                  <Typography variant="h6" sx={{ marginTop: 2 }}>
                    Datos de la Solicitud
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="body1"><strong>Estudiante:</strong> {detalleData.estudiante}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                    <SolicitarAyudForm token={token} estudiante={estudiante} idProyecto={detalleData.proyectoAyud.iddecinvproyecto} onResponse={handleResponseForm} ayudantia={detalleData} periodoActivo={data.periodoActivo} onClose={handleCloseModalEditar}/>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
                    </>}
          />

          <SmallModal
            title='Eliminar Solicitud'
            open={isModalEliminar}
            onClose={handleCloseModalEliminar}
            content={<>
            <Card sx={{ margin: 2 }}>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {detalleData.tituloProyecto}
                  </Typography>
                  {/* Sección de Itinerario */}
                  <Typography variant="h6" sx={{ marginTop: 2 }}>
                    Datos de la Solicitud
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="body1"><strong>Estudiante:</strong> {detalleData.estudiante}</Typography>
                      <Typography variant="body1"><strong>Descripción:</strong> {detalleData.proyectoAyud.descripcion}</Typography>
                      <Typography variant="body1"><strong>Termino:</strong> {detalleData.proyectoAyud.termino+"-"+detalleData.proyectoAyud.anio}</Typography>
                      <Typography variant="body1"><strong>Número de Horas:</strong> {detalleData.detalle.numhoras+" horas"}</Typography>
                    </Grid>
                    <Grid item xs={12}
                      sm={12}
                      container // Añadir esto para activar el comportamiento de flexbox en el Grid
                      direction="row"
                      justifyContent="flex-end" // Cambiado a 'flex-end' para alinear a la derecha
                      alignItems="center"
                    >
                      <Button variant="contained" style={{ backgroundColor: 'red', color: 'white' }} onClick={() => { EliminarAyudantia(detalleData.detalle.iddetallesolicitudayud) }} >
                        Eliminar
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
                    </>}
          />

        </Paper>



    )

} 
  


  

